module.exports = __webpack_public_path__ + "static/media/timerIcon.fcc39863.svg";